@if (control) {
  <mat-form-field [floatLabel]="floatLabel()">
    <mat-label>{{ label() }}</mat-label>
    <mat-select
      [placeholder]="placeholder()"
      [multiple]="multiple()"
      [formControl]="control"
      disableOptionCentering
      >
      @if (firstOption()) {
        <mat-option
          [value]="firstOption()?.id"
          [disabled]="disabledOptions()"
          >{{ firstOption()?.name }}</mat-option
          >
        }
        @if (options()) {
          @for (option of options(); track option.id) {
            <mat-option
              [value]="option.id"
              [disabled]="disabledOptions()"
              >{{ option.name }}</mat-option
              >
            }
          }
          @if (manualOptions()) {
            @for (lookup of manualOptions(); track lookup.value) {
              <mat-option
                [value]="lookup.value"
                [disabled]="disabledOptions()"
                >{{ lookup.name }}</mat-option
                >
              }
            }
          </mat-select>
          @if (control.hasError('required')) {
            <mat-error>Required</mat-error>
          }
          @if (control.hasError('message')) {
            <mat-error [id]="''">{{ control.getError('message') }}</mat-error>
          }
        </mat-form-field>
      }
